import type {
  ActivityPreferredDateDto,
  CreateActivityPreferredDatePayload,
  UpdateActivityPreferredDatePayload,
} from 'src/types/dto/activity-preferred-date.dto';

import axios, { endpoints } from 'src/utils/axios';

export async function listActivityPreferredDates(
  activityId: number
): Promise<ActivityPreferredDateDto[]> {
  const response = await axios.get<ActivityPreferredDateDto[]>(
    endpoints.activities.preferredDates(activityId)
  );
  return response.data;
}

export async function createActivityPreferredDate(
  activityId: number,
  payload: CreateActivityPreferredDatePayload
): Promise<ActivityPreferredDateDto> {
  const response = await axios.post<ActivityPreferredDateDto>(
    endpoints.activities.preferredDates(activityId),
    payload
  );
  return response.data;
}

export async function updateActivityPreferredDate(
  activityId: number,
  preferredDateId: number,
  payload: UpdateActivityPreferredDatePayload
): Promise<ActivityPreferredDateDto> {
  const response = await axios.put<ActivityPreferredDateDto>(
    endpoints.activities.preferredDate(activityId, preferredDateId),
    payload
  );
  return response.data;
}

export async function deleteActivityPreferredDate(
  activityId: number,
  preferredDateId: number
): Promise<void> {
  await axios.delete(endpoints.activities.preferredDate(activityId, preferredDateId));
}

export async function batchAddExcludedDates(payload: {
  activityIds: number[];
  startDate: string;
  endDate: string;
}): Promise<void> {
  await axios.post(endpoints.activities.batchExcludedDates, payload);
}
